/* eslint-disable camelcase */
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'
import { selectUser } from './user'
import axios from 'axios'
import { List } from 'immutable'
import { get } from 'lodash-es'
import { normalize } from 'normalizr'

import { makeGetFullUserByUsername } from './entities'
import { showError } from './errors'
import { requestUserData } from './cardUserData'

import { collection } from '../schemas'

import API from '../config'
import { getHeaders } from './api'

const rootApi = `${API.apiPath}/${API.apiVersion}/`

export const REQUEST_EDIT_CARD = 'REQUEST_EDIT_CARD'
const REQUEST_UPDATE_CARD_INFO = 'REQUEST_UPDATE_CARD_INFO'
const REQUEST_ADD_IMAGE_TO_CARD = 'REQUEST_ADD_IMAGE_TO_CARD'
const REQUEST_POST = 'REQUEST_POST'
export const RECEIVE_POST = 'RECEIVE_POST'
export const RECEIVE_POST_ERROR = 'RECEIVE_POST_ERROR'
export const RECEIVE_UPDATED_POST = 'RECEIVE_UPDATED_POST'
const REMOVE_POST = 'REMOVE_POST'
export const REQUEST_CHILDREN = 'REQUEST_CHILDREN'
export const RECEIVE_CHILDREN = 'RECEIVE_CHILDREN'
export const REMOVE_CHILDREN = 'REMOVE_CHILDREN'
export const REPLACE_CHILDREN = 'REPLACE_CHILDREN'
const RETURN_POSTS_TO_PREVIOUS = 'RETURN_POSTS_TO_PREVIOUS'
const SET_SUGGESTED_IMAGES = 'SET_SUGGESTED_IMAGES'
const TOGGLE_IMAGE_SECTION = 'TOGGLE_IMAGE_SECTION'
const SET_SELECTED_THUMBNAIL = 'SET_SELECTED_THUMBNAIL'
const SET_SELECTED_SQUARE_THUMBNAIL = 'SET_SELECTED_SQUARE_THUMBNAIL'
const SET_SELECTED_POSTER_THUMBNAIL = 'SET_SELECTED_POSTER_THUMBNAIL'
const INIT_SUGGESTIONS = 'INIT_SUGGESTIONS'
const SET_SUGGESTIONS_EDITED = 'SET_SUGGESTIONS_EDITED'
const CHANGE_SUGGESTED_TITLE_INPUT = 'CHANGE_SUGGESTED_TITLE_INPUT'
const ADD_SUGGESTED_TITLE = 'ADD_SUGGESTED_TITLE'
const SET_SELECTED_NAME = 'SET_SELECTED_NAME'
const UPDATE_SUGGESTED_TITLE = 'UPDATE_SUGGESTED_TITLE'
const SET_SELECTED_TAGS = 'SET_SELECTED_TAGS'
const SET_SELECTED_MEDIA_TAGS = 'SET_SELECTED_MEDIA_TAGS'
export const SET_IMAGE_FOR_ALL_THUMB_TYPES = 'SET_IMAGE_FOR_ALL_THUMB_TYPES'

export function requestEditCard(payload) {
  return { type: REQUEST_EDIT_CARD, payload }
}

export function requestUpdateCardInfo(payload) {
  return { type: REQUEST_UPDATE_CARD_INFO, payload }
}

export function requestAddImageToCard(payload) {
  return { type: REQUEST_ADD_IMAGE_TO_CARD, payload }
}

export function requestPost(id, params) {
  return { type: REQUEST_POST, id, params }
}

export function receivePost(data) {
  return { type: RECEIVE_POST, payload: { data } }
}

export function receivePostError(data) {
  return { type: RECEIVE_POST_ERROR, payload: { data } }
}

export function removePost() {
  return { type: REMOVE_POST }
}

export function requestChildren(payload) {
  return {
    type: REQUEST_CHILDREN,
    payload
  }
}

export function receiveChildren(payload, cardId) {
  return { type: RECEIVE_CHILDREN, payload, cardId }
}

export function removeChildren(payload) {
  return { type: REMOVE_CHILDREN, payload }
}

export function receiveReplaceChildren(payload) {
  return { type: REPLACE_CHILDREN, payload }
}

export const setSuggestedImages = payload => ({
  type: SET_SUGGESTED_IMAGES,
  payload
})

export const toggleImageSection = payload => ({
  type: TOGGLE_IMAGE_SECTION,
  payload
})

export const setSelectedThumbnail = payload => ({
  type: SET_SELECTED_THUMBNAIL,
  payload
})

export const setSelectedSquareThumbnail = payload => ({
  type: SET_SELECTED_SQUARE_THUMBNAIL,
  payload
})

export const setSelectedPosterThumbnail = payload => ({
  type: SET_SELECTED_POSTER_THUMBNAIL,
  payload
})

export const initSuggestions = payload => ({
  type: INIT_SUGGESTIONS,
  payload
})

export const setSuggestionsEdited = payload => ({
  type: SET_SUGGESTIONS_EDITED,
  payload
})

export const changeSuggestedTitleInput = payload => ({
  type: CHANGE_SUGGESTED_TITLE_INPUT,
  payload
})

export const addSuggestedTitle = payload => ({
  type: ADD_SUGGESTED_TITLE,
  payload
})

export const setSelectedName = payload => ({
  type: SET_SELECTED_NAME,
  payload
})

export const updateSuggestedTitle = payload => ({
  type: UPDATE_SUGGESTED_TITLE,
  payload
})

export const setSelectedTags = payload => ({
  type: SET_SELECTED_TAGS,
  payload
})

export const setSelectedMediaTags = payload => ({
  type: SET_SELECTED_MEDIA_TAGS,
  payload
})

export const setImageForAllThumbTypes = payload => ({
  type: SET_IMAGE_FOR_ALL_THUMB_TYPES,
  payload
})

function* getPost(action) {
  const url = `${rootApi}deck/get_plain_card`

  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const headers = getHeaders(token)
  const collectionThumbnails =
    get(action, 'params.collectionThumbnails') === 'square' ? 'squared' : get(action, 'params.collectionThumbnails')

  try {
    const params = { card_id: action.id }
    if (get(action, 'params.refId')) {
      params.referrer_id = action.params.refId
    }
    if (collectionThumbnails) {
      params.collectionThumbnails = collectionThumbnails
    }
    const response = yield call([axios, 'get'], url, {
      headers,
      params
    })
    const normalizedCard = normalize(response.data.card, collection)
    yield put(requestUserData(normalizedCard.entities.cards))
    yield put(receivePost(normalizedCard))
  } catch (e) {
    yield put(receivePostError([action.id, e.response.data.error_code]))
  }
}

function* getChildren(action) {
  const url = `${rootApi}deck/get_children_cards`
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const headers = getHeaders(token)
  let { limit, start, sortingOrder } = action.payload
  const { cardId, refId, collectionThumbnails, ref, replace, keyword } = action.payload
  let referrer
  limit = limit || 10
  start = start || 0

  const params = { card_id: cardId, start, limit, sorting_order: sortingOrder, keyword }
  if (refId) {
    params.referrer_id = refId
  } else if (ref) {
    const getUser = makeGetFullUserByUsername()
    referrer = yield select(getUser, ref)
    params.referrer_id = referrer.get('id')
  }
  if (collectionThumbnails) {
    params.collection_thumbnails = collectionThumbnails
  }

  const response = yield call([axios, 'get'], url, {
    headers,
    params
  })
  yield put(receiveChildren(action.payload, action.payload.cardId))
  if (!replace) {
    const normalizedCard = normalize({ id: cardId, children_links: response.data.children }, collection)
    yield put(requestUserData(normalizedCard.entities.cards))
    yield put(receivePost(normalizedCard))
  } else {
    yield put(receiveReplaceChildren({ children: response.data.children, cardId: cardId }))
  }
}

function* editCard(action) {
  const user = yield select(selectUser)
  const { payload } = action
  const { id, name, description, tags, thumbnail } = payload
  const token = get(user, 'data.auth_token')
  const headers = getHeaders(token)

  const response = yield call(
    [axios, 'post'],
    'deck/edit_card',
    {
      card_id: id,
      name,
      description,
      tags,
      thumbnail
    },
    {
      baseURL: rootApi,
      headers
    }
  )
  const normalizedCard = normalize(response.data.card, collection)
  yield put(receivePost(normalizedCard))
}

function* updateCardInfo(action) {
  const user = yield select(selectUser)
  const { payload } = action
  const { id, name, tags, media_tags, image_url, squared_image_url, poster_image_url } = payload
  const token = get(user, 'data.auth_token')
  const headers = getHeaders(token)

  try {
    const response = yield call(
      [axios, 'post'],
      'deck/update-card-info',
      {
        card_id: id,
        title: name,
        tags: tags.join(','),
        media_tags: media_tags.join(','),
        image_url,
        squared_image_url,
        poster_image_url
      },
      {
        baseURL: rootApi,
        headers
      }
    )
    const normalizedCard = normalize(response.data.card, collection)
    yield put(receivePost(normalizedCard))
  } catch (e) {
    yield put(showError("Error. Card Info wasn't updated."))
  } finally {
  }
}

function* processAddSuggestedImage({ payload }) {
  const user = yield select(selectUser)
  const { card_id, image_url, thumbnailType, allThumbnails } = payload
  const token = get(user, 'data.auth_token')
  const headers = getHeaders(token)

  try {
    const response = yield call(
      [axios, 'post'],
      'deck/add-image-from-url',
      {
        card_id,
        image_url,
        thumbnail_type: thumbnailType
      },
      {
        baseURL: rootApi,
        headers
      }
    )
    const { data } = response
    const card = normalize(data.card, collection)
    if (allThumbnails) {
      const addedImage = data.added_image
      yield put(setImageForAllThumbTypes(addedImage))
    }
    yield put(receivePost(card))
  } catch (e) {
    yield put(showError('Unable to upload the image'))
  } finally {
  }
}

export function* cardSaga() {
  yield takeLatest(REQUEST_POST, getPost)
  yield takeLatest(REQUEST_CHILDREN, getChildren)
  yield takeEvery(REQUEST_EDIT_CARD, editCard)
  yield takeEvery(REQUEST_UPDATE_CARD_INFO, updateCardInfo)
  yield takeLatest(REQUEST_ADD_IMAGE_TO_CARD, processAddSuggestedImage)
}

export const selectCard = getState => {
  return getState.card
}

const initialState = {
  posts: List(),
  initialLength: 0,
  suggestedImages: List(),
  isImageSectionOpened: false,
  selectedThumbnail: '',
  selectedSquareThumbnail: '',
  selectedPosterThumbnail: '',
  isEdited: false,
  inputTitle: '',
  suggestedTitles: [],
  selectedName: '',
  selectedTags: List(),
  selectedMediaTags: List()
}

export default function(state = initialState, action) {
  const { payload } = action

  const { posts } = state
  // const index = findIndex(posts, i => i && i.id === (action.id || action.cardId))

  switch (action.type) {
    case RECEIVE_UPDATED_POST:
      const position = posts.findIndex(p => p.id === action.id)
      if (posts.filter(p => p.id === action.id).length) {
        return {
          ...state,
          posts: new List([...posts.slice(0, position), ...[payload], ...posts.slice(position + 1)])
        }
      } else {
        return state
      }
    case REMOVE_POST:
      return { ...state, posts: posts.pop() }
    // case RECEIVE_CHILDREN:
    //   return {
    //     ...state,
    //     posts: posts
    //       .setIn([index, 'children_links'], posts.getIn([index, 'children_links'] || []))
    //       .setIn(
    //         [index, 'children_links'],
    //         uniqBy([...posts.getIn([index, 'children_links'], ...action.payload)], 'id')
    //       )
    //   }
    case RETURN_POSTS_TO_PREVIOUS:
      return { ...state, posts: posts.splice(state.initialLength), initialLength: 0 }
    case SET_SUGGESTED_IMAGES:
      return { ...state, suggestedImages: payload }
    case TOGGLE_IMAGE_SECTION:
      return { ...state, isImageSectionOpened: !state.isImageSectionOpened }
    case SET_SELECTED_THUMBNAIL:
      return { ...state, selectedThumbnail: payload }
    case SET_SELECTED_SQUARE_THUMBNAIL:
      return { ...state, selectedSquareThumbnail: payload }
    case SET_SELECTED_POSTER_THUMBNAIL:
      return { ...state, selectedPosterThumbnail: payload }
    case INIT_SUGGESTIONS:
      return {
        ...state,
        suggestedImages: [],
        isImageSectionOpened: false,
        selectedThumbnail: null,
        isEdited: false,
        titleInput: '',
        suggestedTitles: []
      }
    case SET_SUGGESTIONS_EDITED:
      return { ...state, isEdited: true }

    case CHANGE_SUGGESTED_TITLE_INPUT:
      return { ...state, titleInput: payload }
    case ADD_SUGGESTED_TITLE:
      return { ...state, suggestedTitles: [...new Set([payload, ...state.suggestedTitles])] }
    case SET_SELECTED_NAME:
      return { ...state, selectedName: payload }
    case UPDATE_SUGGESTED_TITLE:
      state.suggestedTitles.splice(payload.index, 1, payload.value)
      return { ...state }
    case SET_SELECTED_TAGS:
      return { ...state, selectedTags: List(payload) }
    case SET_SELECTED_MEDIA_TAGS:
      return { ...state, selectedMediaTags: List(payload) }
    default:
      return state
  }
}
